module.exports = __webpack_public_path__ + "img/doc-video-chat.09fbf42b.svg";